import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { TripAdvisorComment } from "@b2bportal/lodging-api";
import { useCustomerReview } from "@tenant/hotels";
import { Icon, TripadvisorRatingIcon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CustomerReview.module.scss";

export interface CustomerReviewComponentProps extends PlatformComponentProps {
  review: TripAdvisorComment;
}

const COMPONENT_KEY = CoreHotelsComponent.CustomerReview;

export const CustomerReviews = (props: CustomerReviewComponentProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { children, className } = props;

  const { context, text } = useCustomerReview(props);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("title")}>{text.title}</div>
      <div className={cn("rating-icon")}>
        <Icon
          className={cn("tripadvisor-icon")}
          iconName={IconNameEnum.tripadvisor}
        />
        <TripadvisorRatingIcon scoreOutOfFive={context.rating} />
      </div>
      <div className={cn("review")}>
        {text.content.map((line, index) => (
          <p key={index}>{line}</p>
        ))}
      </div>
      <div className={cn("review-info")}>{text.reviewInfo}</div>
      {children}
    </div>
  );
};
